/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Notion_W3Inputs */

const en_mk_cmp_notion_w3 = /** @type {(inputs: Mk_Cmp_Notion_W3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your team already keeps all its documentation there and does not want to move it.`)
};

const id_mk_cmp_notion_w3 = /** @type {(inputs: Mk_Cmp_Notion_W3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim Anda sudah menyimpan seluruh dokumentasinya di sana dan tidak ingin memindahkannya.`)
};

/**
* | output |
* | --- |
* | "Your team already keeps all its documentation there and does not want to move it." |
*
* @param {Mk_Cmp_Notion_W3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_notion_w3 = /** @type {((inputs?: Mk_Cmp_Notion_W3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Notion_W3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_notion_w3(inputs)
	return en_mk_cmp_notion_w3(inputs)
});